import {
  themeLabel as cozyThemeLabel,
  brandVariants as cozyBrandVariants,
  themeDark as cozyThemeDark,
  themeLight as cozyThemeLight,
} from './themes/cozy';

import {
  themeLabel as compactThemeLabel,
  brandVariants as compactBrandVariants,
  themeDark as compactThemeDark,
  themeLight as compactThemeLight,
} from './themes/compact';

import type { AdsUIThemes } from './themes/types';

/**
 * Ads UI themes
 *
 * @public
 *
 * cozy: Cozy theme for ads products
 * compact: Compact theme for ads products
 *
 * Light and dark themes are based on web Fluent UI themes
 *
 * @example
 * themes.cozy.light: Cozy light theme
 * themes.compact.dark: Compact dark theme
 */
export const themes: AdsUIThemes = {
  cozy: {
    label: cozyThemeLabel,
    light: cozyThemeLight,
    dark: cozyThemeDark,
    brandVariants: cozyBrandVariants,
  },
  compact: {
    label: compactThemeLabel,
    light: compactThemeLight,
    dark: compactThemeDark,
    brandVariants: compactBrandVariants,
  },
};
